import React from 'react';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

const App = () => {

  return (
    <div className="min-h-screen transition-all overflow-hidden">
      <Header />
      <About />
      <Projects />
      <Contact />
      <SpeedInsights />
      <Analytics />
    </div>
  );

};

export default App;
